<template>
  <div class="register absolute" style="color: #000;">
    <div class="register_tit">
      <img @click="fanhui" src="../../../assets/images/licai/fanhui.png" />
      <p class="" style="font-weight">{{ $t("m.hz_span0") }}</p>
    </div>
    <div class="register_block">
      <div style="width:100%;overflow: hidden;border-radius:6px;">
        <img
          style="width: 100%;height: auto;object-fit: cover;border-radius:6px;"
          src="../../../assets/images/img/img/tixianx.jpg"
          alt=""
        />
      </div>
      <div
        style="border-radius:8px;background:#fff;padding:15px 10px;margin-top:8px; display:flex;align-items:center;height: 70px;  justify-content: space-around;padding:0 0px;"
      >
        <div style="text-align:center;flex:1;">
          <p style="color:#000;">
            <span style="font-size:20px;font-weight:bold;">{{
              userInfo.usdt
            }}</span>
          </p>
          <p style="font-size:13px;color:#666;margin-top:4px;">
            {{ $t("m.hz_span1") }}
          </p>
        </div>
        <div style="text-align:center;flex:1;">
          <p style="color:#000;">
            <span style="font-size:20px;font-weight:bold;">{{
              userInfo.money
            }}</span>
          </p>
          <p style="font-size:13px;color:#666;margin-top:4px;">可用余额</p>
        </div>
      </div>
      <div
        style="border-radius:8px;background:#fff;padding:15px 10px;margin-top:8px;padding-top:0;"
      >
        <div
          style="font-size:26px;font-weight:bold;padding-left:0px;margin-top:10px;line-height:50px;display:flex;align-items:center;"
        >
          <div style="width:60px;font-size:15px;">{{ $t("m.hz_span3") }}</div>
          <div style="flex:1;">
            <input
              readonly="readonly"
              ref="email"
              style="font-size:15px;margin-left:20px;border-bottom:1px solid #eee;line-height:50px;width: 100%;flex:1;"
              v-model="fangshi"
              @click="show1 = true"
            />
          </div>
          <div style="width: 20px;">
            <img
              @click="gg"
              src="../../../assets/images/new/xiangxia.png"
              style="width: 15px;height: 15px;"
              alt=""
            />
          </div>
        </div>
        <div
          style="font-size:26px;font-weight:bold;padding-left:0px;margin-top:10px;line-height:50px;display:flex;align-items:center;"
        >
          <div style="width:60px;font-size:15px;">{{ $t("m.hz_span4") }}</div>
          <div style="flex:1;">
            <input
              ref="email"
              type="number"
              style="font-size:15px;margin-left:20px;border-bottom:1px solid #eee;line-height:50px;width: 100%;flex:1;"
              v-model="money"
              @input="shurus"
            />
          </div>
          <div style="width: 20px;">
            <img
              @click="gg"
              src="../../../assets/images/licai/guanbi1.png"
              style="width: 20px;height: 20px;"
              alt=""
            />
          </div>
        </div>

        <div style="display:flex;margin-top:20px;align-items:center;">
          <span
            style="color:#666; font-size:15px;width: 60px;font-weight:bold;"
            >{{ $t("m.jf_span7") }}</span
          >
          <textarea
            v-model="bz"
            style="flex:1; margin-left:20px;border:1px solid #eee;border-radius:8px;height: 80px;padding:5px;"
            :placeholder="$t('m.hz_span5')"
            cols="30"
            rows="10"
          ></textarea>
        </div>
      </div>
      <div class="register_submit" @click="register_submit">
        {{ $t("m.hz_span7") }}
      </div>
      <div
        style="font-size:26px;font-weight:bold;padding-left:0px;margin-top:10px;line-height:30px;display:flex;align-items:center;"
      >
        <span style="font-size:13px;color:var(--bg-color);"
          >{{ $t("m.hz_span6") }}：{{ huilv }}</span
        >
        <div
          v-if="daozhang != ''"
          style="text-align:right;flex:1; font-size:13px;color:var(--bg-color);"
        >
          {{ $t("m.hz_span2") }}：{{ daozhang }}
        </div>
      </div>
      <!-- <div
        style="font-size:18px;font-weight:blod;text-align:right;overflow: hidden;margin-top:20px;"
      >
        <div
          @click="dianjis"
          style="float:right; font-weight:blod; display:flex;align-items:center;justify-content:center; width: 220px;height: 40px;border-radius:25px;color:#fff;background:#ff1900;font-size:14px;"
        >
          <img
            src="../../../assets/images/kf.png"
            style="margin-right:5px; width: 20px;height: 20px;"
            alt=""
            srcset=""
          />
          <span>{{$t('m.ct_span2')}}</span>
        </div>
      </div> -->
    </div>

    <div
      v-if="show"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;"
    >
      <div
        style="color:#000; position: absolute;bottom:1rem;left:0;width:100%;height: 60vh;background:#fff;border-radius:5px 5px 0 0;padding:10px;"
      >
        <img
          src="../../../assets/images/licai/guanbi2.png"
          @click="guanbi"
          style="width: 20px;height: 20px;"
          alt=""
        />
        <div style="text-align:center;font-size:15px;margin-top:20px;">
          {{ $t("m.jy_span4") }}
        </div>
        <div
          style="text-align:center;font-size:11px;padding-bottom:30px;border-bottom:1px solid #eee;"
        >
          ¥ <span style="font-size:40px;">{{ money }}</span>
        </div>
        <div
          style="display:flex;align-items:center;font-size:16px;font-weight:bold;margin-top:10px;color:#000; height: 40px;"
        >
          <span style="width: 100%;">{{ $t("m.ct_span3") }}</span>
        </div>
        <div
          @click="backShow1(0)"
          style="display:flex;align-items:center;font-size:14px;height: 40px;"
        >
          <span style="flex:1;display: flex;">{{ $t("m.ct_span4") }}</span>
          <img
            :src="xuan == 0 ? img1 : img2"
            style="width: 20px;height: 20px;margin-left:10px;"
            alt=""
          />
        </div>
        <div
          @click="backShow1(1)"
          style="display:flex;align-items:center;font-size:15px;height: 40px;"
        >
          <span style="flex:1;display: flex;">{{ $t("m.ct_span5") }}</span>
          <img
            :src="xuan == 1 ? img1 : img2"
            style="width: 20px;height: 20px;margin-left:10px;"
            alt=""
          />
        </div>
        <div
          class="register_submit"
          style="margin-top:50px;"
          @click="register_submit"
        >
          {{ $t("m.ct_span6") }}
        </div>
      </div>
    </div>
    <van-action-sheet
      v-model="show1"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
    ></van-action-sheet>

    <van-dialog
      confirmButtonColor="#ff1900"
      v-model="passwordShow"
      :title="$t('m.yh_span7')"
      show-cancel-button
      @confirm="pwdChange2"
      @cancel="pwd = ''"
      @close="pwd = ''"
    >
      <div class="zfmm">
        <van-field
          v-model="pwd"
          :placeholder="$t('m.ct_span11')"
          type="password"
        />
      </div>
    </van-dialog>
    <div
      v-if="shows"
      style="background: rgba(0, 0, 0, 0.5);position: fixed;width: 100%;height: 100%;left:0;top:0;display: flex;align-items: center;justify-content: center;"
    >
      <div
        style="background: rgba(0, 0, 0, 0.7);width:130px;height:130px;border-radius:8px;text-align:center;line-height:130px;color:#fff;font-size:16px;"
      >
        {{ $t("m.tijiaoing") }}
      </div>
    </div>
    <div style="height: 70px;"></div>
  </div>
</template>

<script>
import Vue from "vue";
import { ActionSheet } from "vant";

Vue.use(ActionSheet);
import request from "@utils/request";
import { getMyUserInfo } from "@api/user";
import $store from "../../../store";
export default {
  name: "CzContent",
  data: function() {
    return {
      passwordShow: false,
      xuanze: 0,

      xuan: 0,
      daozhang: "",
      img1: require("../../../assets/images/new/xuanzhong.png"),
      img2: require("../../../assets/images/new/weixuanzhong.png"),
      show1: false,
      show: false,
      shows: false,
      money: "",
      mima: "",
      dicdata: {},
      list: [],
      bz: "",
      pwd: "",
      huilv: 1,
      userInfo: {},
      bzs: ""
    };
  },
  computed: {
    actions: function() {
      return [
        { name: this.$t("m.hz_span8"), index: 0 },
        { name: this.$t("m.hz_span9"), index: 1 }
      ];
    },
    fangshi: function() {
      return this.$t("m.hz_span8");
    }
  },
  mounted: function() {
    this.$refs.email.focus();
    let that = this;
    setTimeout(function() {
      getMyUserInfo().then(res => {
        let userInfo = res.data.data;
        that.userInfo = userInfo;
        if (userInfo.is_auth != 1) {
          //  that.$dialog.message("请先完成实名认证");
          that.$router.push({ name: "memmber_business" });
        }
      });
    }, 500);
    request
      .post("/pay/us/cache", {}, { login: true })
      .then(res => {
        console.log(res);
        let userInfo = res.data.data;
        this.huilv = (userInfo.usd_cny * userInfo.usdt_usdk).toFixed(2);
      })
      .catch(err => {
        this.$dialog.error(err.response.data.msg);
      });
  },
  methods: {
    shurus() {
      let shuru = this.money;
      if (this.xuanze == 1) {
        let cc = parseFloat(shuru * this.huilv).toFixed(4);
        this.daozhang = cc + " 人民币";
      } else {
        let cc = parseFloat(shuru / this.huilv).toFixed(4);
        this.daozhang = cc + " USDT";
      }
    },
    pwdChange2() {
      let vm = this;
      vm.passwordShow = false;
      vm.shows = true;
      if (this.xuanze == 0) {
        let dic = { amount: this.money, remark: this.bz, pwd: this.pwd };
        request
          .post("/pay/us/cny-usdt", dic, { login: true })
          .then(res => {
            this.show = false;
            vm.shows = false;
            this.$dialog.success(res.data.msg);
            let view = $store.state.app.view;
            if (view == "local") {
              this.$router.push({
                path: "/mychat"
              });
            } else {
              this.$router.push({
                path: "/customerService"
                // path: "/mychat"
              });
            }
          })
          .catch(err => {
            vm.shows = false;
            this.$dialog.error(err.response.data.msg);
          });
      } else {
        // window.localStorage.setItem("czje",JSON.stringify(dic))
        //  this.$router.push({
        //     path: "/erweima"
        //   });
        let dic = { amount: this.money, remark: this.bz, pwd: this.pwd };
        request
          .post("/pay/us/usdt-cny", dic, { login: true })
          .then(res => {
            this.show = false;
            vm.shows = false;
            this.$dialog.success(res.data.msg);
            let view = $store.state.app.view;
            if (view == "local") {
              this.$router.push({
                path: "/mychat"
              });
            } else {
              this.$router.push({
                path: "/customerService"
                // path: "/mychat"
              });
            }
          })
          .catch(err => {
            vm.shows = false;
            this.$dialog.error(err.response.data.msg);
          });
      }
    },
    onInput(value) {
      let vm = this;
      this.money = vm.money + value;
    },
    onDelete() {
      console.log("sdsdsa");
      this.money = this.money.slice(0, this.money.length - 1);
    },
    fanhui() {
      this.$router.push({
        path: "/"
      });
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      this.show = false;

      this.xuanze = item.index;
      console.log(this.xuanze);
      this.fangshi = item.name;
      if (this.money != "") {
        this.shurus();
      }
    },
    gg() {
      this.money = "";
    },
    backShow1(E) {
      this.xuan = E;
    },
    guanbi() {
      this.show = false;
    },
    dianjis() {
      let view = $store.state.app.view;
      if (view == "local") {
        this.$router.push({
          path: "/mychat"
        });
      } else {
        this.$router.push({
          path: "/customerService"
          // path: "/mychat"
        });
      }
    },
    register_submit() {
      this.passwordShow = true;
    },
    registerReset() {
      if (this.money == "" || this.money <= 0) {
        this.$dialog.message("请输入付款金额");
        return;
      }
      this.show = true;
    }
  }
};
</script>
<style scoped lang="less">
.register_submit {
  width: 100%;
  margin: 0 auto;
  height: 45px;
  background: var(--bg-color);
  border-radius: 30px;
  margin-top: 20px;
  text-align: center;
  line-height: 45px;
  color: #ffffff;
  border: 0px solid;
  font-size: 15px;
  font-weight: bold;
}

/deep/.zfmm {
  padding: 10px;
  padding-bottom: 20px;
  width: 100%;
  text-align: center;
  color: #333333;
  padding-left: 20px;
  padding-right: 20px;

  .van-field {
    background-color: #f1f1f3;
    background-color: #f1f1f3;
  }
}
.register_block {
  padding: 10px;
}
.register_block_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
  margin-top: 15px;
}
.register_code_lists {
  border: 1px solid #ff1900;
  text-align: center;
  color: #ff1900;
  border-radius: 6px;
  width: 36%;
  height: 45px;
  margin-left: 15px;
  line-height: 45px;
}
.register_code_list {
  width: 100%;
  height: 50px;
  padding: 0 15px;
  background: #f1f1f3;
  border-radius: 5px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
.register_code {
  display: flex;
  align-items: center;
  margin-top: 15px;
}
.register_tit {
  background: #fff;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
  padding: 5px;
}
.register_tit img {
  width: 30px;
  height: 30px;
  position: absolute;
  left: 15px;
}
.register_tit p {
  text-align: center;
  text-align: center;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  line-height: 35px;
}
/* 清除浮动*/
.am-fl {
  float: left;
}
.am-fr {
  float: right;
}
.am-cf:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.am-cf {
  zoom: 1;
}
</style>
